<script>
    import Header from "./header-section.svelte";
    import Footer from "./footer.svelte";
    import { drafting_service, drafting_service_mob } from "./header_data.js";
    import Gallary from "./gallary.svelte";
    import { gallary, gallary_mobile } from "./gallary.js";
    import { title, show } from "./store.js";
    import PopUpButton from "./popUp_button.svelte";
    import MobileButton from "./popUp_button_mob.svelte";
    import YourPlan from "./submit_your_plan.svelte";
    title.set("Drafting Services");
    $: console.log("gallary", gallary);

    function displayPopUp() {
        show.update((n) => n + 1);
        console.log("show", show);
    }
</script>

<Header
    data_desktop={drafting_service}
    data_mobile={drafting_service_mob}
    border_color={"0.234vw solid #000000 "}
    top={"100vw"}
    width_des="46.5vw"
    Width_line="38.2vw"
>
    <div slot="btn">
        <div class="desktop" style="margin-top: 0.5vw; margin-left:7.135vw;">
            <PopUpButton
                border_radius="0.625vw"
                padding="1.042vw 3.073vw"
                title="Contact"
                me="2"
                btnStyle="nav_bar_btn"
                px="0"
                on:click={() => {
                    displayPopUp();
                }}
            />
        </div>
        <div class="mobile">
            <MobileButton
                title={"Contact"}
                on:click={() => {
                    displayPopUp();
                }}
            />
        </div>
    </div>
</Header>
<YourPlan />
<div class="desktop">
    <div class="dotted-img-text">
        <div class="dotted-img">
            <img src="images/drafting/dots_lines.svg" alt="" />
        </div>
        <div class="dotted-text">
            <h1 style="font-size: 2.083vw; text-transform: uppercase;">We Provide</h1>
        </div>
    </div>
    <div style="margin-top: 2.948vw; margin-bottom:7vw;">
        <Gallary coming_data={gallary} width="70vw" />
    </div>
</div>
<div class="mobile">
    <!-- <YourPlan /> -->
    <div>
        <div class="title-wrapper">
            <img src="images/drafting/provide.svg" alt="" />
        </div>
        <div style="margin-top: 10.600vw; margin-bottom:30.607vw;">
            <Gallary coming_data={gallary_mobile} width="81.308vw" />
        </div>
    </div>
</div>
<Footer />

<style>
    .dotted-img {
        width: 11.927vw;
        margin-top: 6.563vw;
        margin-left: 43.542vw;
    }
    .dotted-img img {
        width: 100%;
    }
    .dotted-text {
        width: 12.927vw;
        position: absolute;
        left: 44vw;
        top: 49.5vw;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: flex;
            justify-content: center;
        }
        .desktop {
            display: none;
        }
        /* .mobile{
            display: flex;
            justify-content: center;
        } */
        .title-wrapper {
            width: 36.537vw;
            height: 10.514vw;
            margin-top: 22.343vw;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
        }
        .title-wrapper img {
            width: 100%;
            height: 100%;
        }
    }
</style>
